const privacyPolicy = {
  title: 'Privacy Policy',
  intro: 'This policy describes how ProfitYo Global may collect, use, and protect information when you use this website.',
  sections: [
    {
      id: 'information-we-collect',
      title: 'Information We Collect',
      paragraphs: [
        'We may collect information you choose to provide when you contact us, such as your name, email address, and the contents of your message.',
        'Some technical information, such as browser and device details, may be collected when you visit the website.',
      ],
    },
    {
      id: 'how-we-use-information',
      title: 'How We Use Information',
      paragraphs: [
        'We may use information to respond to inquiries, operate and improve the website, and protect its security.',
      ],
    },
    {
      id: 'sharing-and-retention',
      title: 'Sharing and Retention',
      paragraphs: [
        'We do not sell personal information. Information may be shared with service providers who help operate the website or when required by law.',
        'Information is retained only for as long as reasonably necessary for the purposes described in this policy.',
      ],
    },
    {
      id: 'your-choices',
      title: 'Your Choices',
      paragraphs: [
        'To ask a question about this policy or make a privacy-related request, contact us using the email address below.',
      ],
    },
  ],
};

export default privacyPolicy;